import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";

const BookingsPage = () => {
  const [bookings, setBookings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const bookingsRef = ref(database, "bookings/");
    onValue(bookingsRef, (snapshot) => {
      const bookingsData = snapshot.val();
      const bookingsArray = bookingsData
        ? Object.keys(bookingsData).map((key) => ({
            id: key,
            ...bookingsData[key],
          }))
        : [];
      setBookings(bookingsArray);
    });
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <button
        onClick={() => navigate(-1)} // Navigate back to the previous page
        className="mb-4 bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600"
      >
        Back
      </button>
      <h1 className="text-3xl font-bold text-center mb-6">Bookings</h1>
      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-white shadow-lg rounded-lg">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Mobile Number</th>
              <th className="px-4 py-2">Email</th>
              <th className="px-4 py-2">Type of Service</th>
              <th className="px-4 py-2">Address</th>
              <th className="px-4 py-2">Booking Date</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length > 0 ? (
              bookings.map((booking) => (
                <tr key={booking.id} className="text-center">
                  <td className="border px-4 py-2">{booking.name}</td>
                  <td className="border px-4 py-2">{booking.mobile}</td>
                  <td className="border px-4 py-2">{booking.email}</td>
                  <td className="border px-4 py-2">{booking.serviceType}</td>
                  <td className="border px-4 py-2">{booking.address}</td>
                  <td className="border px-4 py-2">{booking.bookingDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="text-center text-gray-500 py-4"
                >
                  No bookings available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingsPage;
